import {
  useIsDefaultFormFieldFontSizeEnabled,
  useIsFormEditorBulkActionsEnabled,
  useIsFormEditorMultiSelectEnabled,
  useIsFormEditorUndoRedoEnabled,
} from '@/features/flags';
import { useIsExcludeFormFieldsFromFillEnabled } from '@/features/flags/exclude-form-fields-from-fill-flag';
import { useIsFormEditorCopyPasteEnabled } from '@/features/flags/form-editor-copy-paste-flag';
import { useIsXfaPdfFormEnabled } from '@/features/flags/xfa-pdf-form-flag';

/**
 * Resolves the form-field editor's seven rollout gates once, at the mount, so the
 * editor surface takes them as data instead of reaching for a flag client.
 *
 * Every getter is called unchanged, which is what keeps the two DEV-on
 * overrides and the `?? false` fallbacks exactly where they already live.
 *
 * Lives in this standalone `.ts` module rather than the `index.tsx` barrel so
 * the hook adds no `react-refresh/only-export-components` warning there.
 *
 * The return type is INFERRED rather than annotated with `FormFieldEditorFlags`:
 * naming `@heidi/templates` here would bind this barrel to a domain's UI door,
 * which the tauri boot paths that import it must not load. The shape is checked
 * where it is consumed — the four mounts' `flags` prop — and pinned by name in
 * the suite beside this file, which the door rule does not scan.
 */
export const useFormFieldEditorFlags = () => {
  return {
    multiSelect: useIsFormEditorMultiSelectEnabled(),
    bulkActions: useIsFormEditorBulkActionsEnabled(),
    undoRedo: useIsFormEditorUndoRedoEnabled(),
    copyPaste: useIsFormEditorCopyPasteEnabled(),
    excludeFromFill: useIsExcludeFormFieldsFromFillEnabled(),
    defaultFontSize: useIsDefaultFormFieldFontSizeEnabled(),
    xfaPdfForm: useIsXfaPdfFormEnabled(),
  };
};
